
import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})
export default class BaseCabecalho extends Vue {
  private titulo = '';

  private funcionalidade = '';

  private colorH1 = '#686868';

  @Prop({ type: Function })
  public functionNovo?: Function;

  @Prop({ type: String, default: 'Novo' })
  public labelBotaoNovo!: string;

  private definirTitulo() {
    if (this.$route.meta.title !== undefined && this.$route.meta.title !== null) {
      this.titulo = this.$route.meta.title;
    }
  }

  private getColorH1() {
    if (this.$vuetify.theme.themes.light.secondary !== undefined && this.$vuetify.theme.themes.light.secondary !== null) {
      return this.$vuetify.theme.themes.light.secondary;
    }
    return this.colorH1;
  }

  mounted() {
    this.definirTitulo();
  }
}
